// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetBookingPricePackageUsageResponse

export type WidgetBookingPricePackageUsageApiResponse = {
	name: string;
	quantity: number;
	unitPrice: number;
	total: number;
	isFlatFee: boolean;
};

export type WidgetBookingPricePackageUsage = {
	name: string;
	quantity: number;
	unitPrice: number;
	total: number;
	isFlatFee: boolean;
};

export function hydrateWidgetBookingPricePackageUsage(data: WidgetBookingPricePackageUsageApiResponse): WidgetBookingPricePackageUsage {
	return { ...data };
}